<template>
  <div class="container">
    <div class="row">
      <div class="col-4 offset-4">
        <h2 class="text-center mt-5">Sign In</h2>
        <div class="alert alert-danger" role="alert" :class="{show: error}">
          {{ error }}
        </div>
        <div class="card mt-5">
          <div class="card-body">
            <form @submit="login">
              <div class="form-group">
                <label for="exampleInputEmail1">Email</label>
                <input type="email" class="form-control" id="email" placeholder="john.doe@provider.com" v-model="form.email">
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input type="password" class="form-control" id="password" placeholder="••••••••" v-model="form.password">
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary mt-3">Sign In</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignIn',
  data () {
    return {
      form: {
        email: '', password: ''
      }
    }
  },
  computed: {
    error () {
      return this.$store.state.authentication.status.error
    }
  },
  created () {
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    login (event) {
      event.preventDefault()
      this.$store.dispatch('authentication/login', { email: this.form.email, password: this.form.password })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
div.alert{
  visibility: hidden;
  opacity: 0;
  transition: all 0.4s ease-out;
  font-size: 13px;
  height: 0px;
  margin-top: 0;

  &.show{
    visibility: visible;
    opacity: 1;
    height: 45px;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SignIn.vue